module.exports = __webpack_public_path__ + "2ce3f1d103fb9e2bff89b15ff38b6834.gif";